package one.healthium.health_advice.ui.message

import androidx.compose.runtime.Immutable

@Immutable
internal data class HealthAdviceMessageUiState(
    val message: String? = null,
)
